__turbopack_context__.v({
  "playButton": "video-module__aE5NSW__playButton",
  "pointer": "video-module__aE5NSW__pointer",
  "video": "video-module__aE5NSW__video",
});
